import 'modern-normalize/modern-normalize.css';
import axios from 'axios';
import Cookies from 'js-cookie';
import { uniq } from 'lodash';
import React from 'react';
import Helmet from 'react-helmet';
import cx from 'classnames';

import Header from '../Header';
import MobileNav from '../MobileNav';
import Announcement from '../Announcement';

import styles from './index.module.scss';

import './global.scss';

import favicon from '../../../static/favicon.png';

/* eslint-disable react/prop-types */
export default class Layout extends React.Component {
  state = {
    navActive: false,
    announcements: [],
    hiddenAnnouncements: [],
  };

  componentWillMount() {
    this.setState({
      hiddenAnnouncements: Cookies.getJSON('closed_announcements') || [],
    });
  }

  async componentDidMount() {
    try {
      const resp = await axios({
        method: 'get',
        url: `/api/v1/announcements`,
        headers: {
          'accept-language': `${this.props.locale}`,
        },
      });
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        announcements: resp.data.data || [],
      });
    } catch (err) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        announcements: [],
      });
    }
  }

  closeAnnouncement = id => {
    const closedAnnouncements = Cookies.getJSON('closed_announcements') || [];
    Cookies.set('closed_announcements', uniq([...closedAnnouncements, id]), { path: '/', expires: 1 });
    this.setState({
      hiddenAnnouncements: Cookies.getJSON('closed_announcements') || [],
    });
  };

  render() {
    const { children, locale, showHeader, fixedHeader } = this.props;
    const { navActive, announcements, hiddenAnnouncements } = this.state;

    return (
      <React.Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <meta httpEquiv="x-ua-compatible" content="ie=edge" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0, shrink-to-fit=no"
          />
          {locale === 'en' ? (
            <meta
              name="description"
              content="Kingston International School offers an IB-PYP bilingual (English/Putonghua) programme for students aged 1 to 11 years of age. Kingston has three campuses - the Kindergarten and Children's Centre which houses our early years programme for children 1 to 4 years of age, a Lower Primary campus for students from Year 1 to Year 3 and an Upper Primary campus for students from Year 4 to Year 6. "
            />
          ) : (
            <meta
              name="description"
              content="京斯敦國際學校為一歲至十一歲的學生提供國際文憑小學雙語課程(英文／普通話)。京斯敦共有三所校舍：幼兒園及幼稚園部為一至四歲學生提供幼兒教育課程、低年級校舍供一年級至三年級學生就讀，而高年級校舍則供四年級至六年級學生就讀。雖然分成三所校舍，但我們依然是一所溫馨舒適的小型學校。我們推行小班教學，每班分別有兩位母語為普通話及英文的班主任。"
            />
          )}
          <link rel="icon" href={favicon} sizes="64x64" />
          <title>{locale === 'en' ? 'Kingston International School Hong Kong' : '京斯敦國際學校(香港)'}</title>
        </Helmet>

        {showHeader && (
          <MobileNav locale={locale} isActive={navActive} onClose={() => this.setState({ navActive: false })} />
        )}
        <main
          className={cx({
            [styles.root]: true,
            [styles.shift]: showHeader && navActive,
          })}
        >
          {showHeader && (
            <Header locale={locale} fixed={fixedHeader} onToggle={() => this.setState({ navActive: !navActive })} />
          )}
          {children}

          <div className={styles.announcementsWrapper}>
            {announcements.map(announcement => (
              <Announcement
                key={announcement._id}
                locale={locale}
                isClosed={hiddenAnnouncements.includes(announcement._id)}
                onClose={this.closeAnnouncement}
                {...announcement}
              />
            ))}
          </div>
        </main>
      </React.Fragment>
    );
  }
}
